// extracted by mini-css-extract-plugin
module.exports = {"proceedButton":"styles_proceedButton__zqG-P","stacked":"styles_stacked__2Zkoz","disabled":"styles_disabled__wmsz5"};